import OneSignal from "react-onesignal";

let isOneSignalInitialized = false;

const Notifications = async (externalUserId) => {
  if (!isOneSignalInitialized) {
    try {
      const appId = process.env.REACT_APP_ONESIGNAL_APP_ID;
      const safariWebId = process.env.REACT_APP_ONESIGNAL_SAFARI_WEB_ID;

      if (!appId) {
        console.warn("OneSignal AppID not configured in environment variables");
        return;
      }

      await OneSignal.init({
        appId,
        safari_web_id: safariWebId,
        notifyButton: {
          enable: true,
        },
        allowLocalhostAsSecureOrigin: true,
      });

      console.log("OneSignal initialized successfully");
      isOneSignalInitialized = true;
    } catch (error) {
      console.warn("OneSignal initialization warning:", error.message);
      return;
    }
  }

  if (externalUserId) {
    try {
      // Tags this browser's push subscription with our internal user id,
      // so the backend can target a specific user via include_external_user_ids.
      await OneSignal.setExternalUserId(String(externalUserId));
    } catch (error) {
      console.warn("OneSignal setExternalUserId warning:", error.message);
    }
  }
};

export default Notifications;
